import React, { useRef } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import DashboardHome from "../screens/dashboard/home";
import HoneyComb from "../screens/HoneyComb";
import JobClaimedInfo from '../screens/JobClaimedInfo';
import DropBuy from "../screens/dashboard/DropBuy";
import Admintools from "../screens/dashboard/admintools";
import JobEditTabs from "../screens/jobDetailsTabs/jobEditTabs"
import ResourcesPage from "../screens/dashboard/resources/ResourcesPage";
import Swarms from "../screens/Swarms/index";
import AdminSwarm from "../screens/AdminSwarm2.0/index";
import NotAccessMessage from "../components/NotAccessMessage";
import { UserType } from "../constants/enums";
import { useUserActionOcurrsMutation } from "../services/accountsApi";
import DocumentsWrapper from "../components/DocumentsWrapper/DocumentsWrapper";

import { useSelector } from "react-redux";
import { selectCurrentUser } from "../features/auth/authSlice";

const ProtectedRoute = ({ path, component: Component, hasAccess, exact = false }) => {
  return (
    <Route 
      exact={exact}
      path={path}
      render={(props) => 
        hasAccess ? <Component {...props} /> : <NotAccessMessage />
      }
    />
  );
};

function DashBoardRouter() {
  const renderCount = useRef(0);
  console.log('[DashboardRouter] render count:', ++renderCount.current);

  let { path } = useRouteMatch();
  const user = useSelector(selectCurrentUser);

  return (
    <DocumentsWrapper user={user}>
      <Switch>
        {/* this routes are not protected because they are protected by default the main dashboard. if user is not logged in, it will redirect to login */}
        <Route exact path={`${path}/home`} component={DashboardHome} />
        <Route exact path={`${path}/jobs`} component={HoneyComb} />
        <Route exact path={`${path}/job/:jobId`} component={JobClaimedInfo} />
        
        <ProtectedRoute
          exact
          path={`${path}/dropBuy`}
          component={DropBuy}
          hasAccess={user?.userDistribution || user?.role === "Admin"}
        />
        
        <ProtectedRoute
          exact
          path={`${path}/resources`}
          component={ResourcesPage}
          hasAccess={user?.userDistribution || user?.role === "Admin"}
        />
        
        <ProtectedRoute
          exact
          path={`${path}/admintools`}
          component={Admintools}
          hasAccess={user?.role === "Admin"}
        />
        
        <ProtectedRoute 
          path={`${path}/admintools/jobs/:jobId`}
          component={JobEditTabs}
          hasAccess={user?.role === "Admin"}
        />
        
        <ProtectedRoute
          exact
          path={`${path}/swarms`}
          component={Swarms}
          hasAccess={user?.useSwarm}
        />
        
        <ProtectedRoute
          exact
          path={`${path}/adminswarm`}
          component={AdminSwarm}
          hasAccess={user?.role === "Admin" && user?.userTypeId !== UserType.HiveAdmin}
        />
      </Switch>
    </DocumentsWrapper>
  );
}

export default DashBoardRouter;